import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as BUCKET_NAME from '../../constants/storageBucket';

const firebaseRef = firebase.database();

export const generateCsv = async (reportIndex, reportName) => {
	//generate the csv
	var generateFile = firebase
		.functions()
		.httpsCallable('generateCsvFromJson');

	console.log('generateCsv', reportIndex, reportName);

	await generateFile({
		projectCode: PROJECT_CODE.projectCode,
		reportId: reportIndex,
		reportName: reportName,
		bucketName: BUCKET_NAME.storageBucket,
	})
		.then(() => {
			console.info('Generated CSV successfully...');
		})
		.catch((error) => {
			console.error('Something bad happened', error.message);
		});
};
